var exports = {
  "kL": "container__rfx-3s",
  "W": "fadein__828t2-",
  "wx": "header__8DCKRC",
  "rf": "body__APdwN2",
  "rX": "flushBody__v9eW-N",
};

module.exports = exports;
